import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import { Loader } from '@components/common';
import utils from '@utils';
import { InvoiceService } from '@services';
import DenialReasonModal from './components/DenialReasonModal';

class EstimatesTable extends Component {
	constructor(props) {
		super(props);

		this._denialReasonModal = React.createRef();
	}

	getStautsLabel = (statusId) => {
		const label = {};

		switch (statusId) {
			case 0:
				label.title = 'Expired';
				label.class = 'label-warning';
				break;
			case 1:
				label.title = 'Approved';
				label.class = 'label-success';
				break;
			case 2:
				label.title = 'Denied';
				label.class = 'label-danger';
				break;
			default:
				label.title = 'Pending';
				label.class = 'label-warning';
				break;
		}

		return label;
	}

	updateEstimateStatus = (invoiceEstimateId, reasonNote = null) => (event) => {
		event.stopPropagation();

		const { updateJobsPage } = this.props;
		const { id } = event.target;

		const approve = id === 'approve-estimate';
		const requestData = {};
		if (!approve) requestData.note = reasonNote;

		InvoiceService.approveEstimateFromId(invoiceEstimateId, { approve }, requestData)
			.then(({ data }) => {
				utils.notify({
					title   : 'Success',
					type    : 'success',
					message : data.Message || 'Estimate updated successfully',
				});
				this._denialReasonModal.current.resetModal();
				updateJobsPage();
			})
			.catch(({ response : { data : { Message } } }) => {
				utils.notify({
					title   : 'Oops',
					type    : 'error',
					message : Message || 'Error updating Estimate',
				});
			});
	}

	openModal = (estimateId) => (event) => {
		event.stopPropagation();
		this._denialReasonModal.current.openModal({ show : true, estimateId });
	};

	handleRowClick = (invoiceEstimateId) => () => {
		const { push } = this.props;
		push(`/InvoiceEstimate/1/${invoiceEstimateId}`);
	}

	render() {
		const {
			rows, loading, timeZone,
		} = this.props;

		return (
			<div className="position-relative margin-bottom-15">
				<div className="padding-horizontal-15">
					<Row className="border-solid border-1 border-color-default padding-vertical-10">
						<Col sm={4}>Job</Col>
						<Col sm={3}>Coordinator</Col>
						<Col sm={2}>Job Starts</Col>
						<Col sm={1} className="text-right">Amount</Col>
						<Col sm={2}> </Col>
					</Row>
					<For
						each="estimate"
						index="index"
						of={rows}
					>
						<Row
							key={`estimate_${index + 1}`}
							className="bg-white border-solid border-1 border-color-default padding-vertical-10 cursor-pointer"
							onClick={this.handleRowClick(estimate.Id)}
						>
							<Col sm={4}>
								<strong className="color-black font-bold">{estimate.JobEventName}</strong>
								<br />
								<span className="font-light">{estimate.AgencyContactName}</span>
							</Col>
							<Col sm={3}>
								<div className="flex">
									<div className="margin-right-10">
										<i className="rkf rkf-business font-size-20" />
									</div>
									<div>
										<strong className="color-black font-bold">{estimate.AgencyName}</strong>
										<br />
										<span className="font-light">{estimate.AgencyContactEmail}</span>
									</div>
								</div>
							</Col>
							<Col sm={2}>
								<strong className="color-black font-bold">
									{utils.parseUTCDateToTimeZone(estimate.JobEventStartDateTime, timeZone).format('dddd, MMMM DD YYYY')}
								</strong>
								<br />
								<span className="font-light">
									Estimate Sent
									{' '}
									{utils.parseUTCDateToTimeZone(estimate.CreateDateUTC, timeZone).fromNow()}
								</span>
							</Col>
							<Col sm={1}>
								<div className="text-right">
									{ utils.currencyFormatter(estimate.Total) }
									{estimate.RequiresPrepayment && (
										<div className="tag tag-success margin-0">Prepay</div>
									)}
								</div>
							</Col>
							<Col sm={2} className="text-center">
								<Button
									id="approve-estimate"
									onClick={this.handleRowClick(estimate.Id)}
									bsStyle="primary"
									className="margin-right-10"
								>
									Review
								</Button>
							</Col>
						</Row>
					</For>
				</div>
				<Loader active={loading} />
				<DenialReasonModal updateEstimateStatus={this.updateEstimateStatus} ref={this._denialReasonModal} />
			</div>
		);
	}
}

EstimatesTable.propTypes = {
	rows           : PropTypes.array.isRequired,
	loading        : PropTypes.bool.isRequired,
	timeZone       : PropTypes.string.isRequired,
	push           : PropTypes.func.isRequired,
	updateJobsPage : PropTypes.func.isRequired,
};

export default EstimatesTable;
